import { render, staticRenderFns } from "./form-container.vue?vue&type=template&id=72edd77c&"
import script from "./form-container.vue?vue&type=script&lang=js&"
export * from "./form-container.vue?vue&type=script&lang=js&"
import style0 from "./form-container.vue?vue&type=style&index=0&id=72edd77c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports